
export default {
  created() {
    this.findParentForm();
  },
  data() { return {
    form: null,
  }},
  methods: {
    findParentForm() {
      let parent = this.$parent;
      while (parent && !this.form) {
        if (typeof parent.registerField === 'function') {
          this.form = parent
        } else {
          parent = parent.$parent;
        }
      }
      if (!parent) {
        console.error('could not find parent form element for form input ', this.name)
      }
    }
  }
}
